import { GhostLoader } from "app/components/React/Table/SWReactTableGhostLoader";
import styled from "styled-components";

const TableLoaderContainer = styled.div<{ height: string }>`
    height: ${({ height }) => `${height}`};
    overflow: hidden;
`;

export const TableLoader = ({ height }) => (
    <TableLoaderContainer height={height}>
        <GhostLoader />
    </TableLoaderContainer>
);
